'use strict';

var DashboardConstants = {
  ALERTS_TYPES: {
    FLIGHT: 'flightAlerts',
    MARKET: 'marketAlerts',
    FARES: 'fimAlerts'
  },
  ALERTS_PANEL_TITLE_PREFIX: {
    FLIGHT: 'Flight',
    MARKET: 'Market',
    FARES: 'Fares'
  }
};
module.exports = DashboardConstants;